import React from "react";
import { Whisper, Tooltip, RadioGroup, Radio } from "rsuite";
import "./opportunities.scss";
import { numberFormatter } from "../../utils";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";

const SuppliersTable = (props: any) => {
	const handleRowClick = (vendorRow: any) => {
		props.updateVendor(vendorRow);
	};

	return (
		<div className="common-table-content">
			<div className="common-table-header-row">
				<div className="common-table-header">Suppliers List</div>
				<div className="flex items-center gap-x-4">
					<RadioGroup
						name="radio-group-inline"
						inline
						value={props.approach}
						onChange={props.onApproachChange}
					>
						{props.approachOptions.map((option: any) => (
							<Radio
								key={option.value}
								value={option.value}
								color="green"
								className={`mr-[2vh] text-black text-[0.6vw] ${ props.showUpdateButton ? 'opportunityRadio' : ''}`}
							>
								{option.label}
								<Whisper
									placement="right"
									speaker={
										<Tooltip className="tooltipconfig">
											<div>{option.tooltip}</div>
										</Tooltip>
									}
								>
									<InfoOutlineIcon className="ml-[.5vh] mb-[.5vh]" />
								</Whisper>
							</Radio>
						))}
					</RadioGroup>
					{props.showUpdateButton && (
						<button
							className="savingButton"
							onClick={props.onUpdateRebate}
							style={{paddingLeft:'1vh', paddingRight:'1vh', fontSize:'1.8vh'}}
						>
							<span>Update Rebate</span>
						</button>
					)}
				</div>
			</div>
			<table className="common-table-ui">
				<thead>
					<tr>
						<th>Supplier</th>
						{/* <th>{new Date().getFullYear()} Forecasted Spend</th> */}
						<th>2026 Forecasted Spend</th>
						<th>Current Effective Rebate</th>
						<th>Best Peer Effective Rebate %</th>
						<th>Opportunity</th>
					</tr>
				</thead>
				<tbody>
					{props.data?.map((d: any, index: any) => {
						const isSelected =
							props.selectedVendor &&
							props.selectedVendor.master_vendor_name ===
								d.master_vendor_name;
						return (
							<tr
								key={index}
								onClick={() => {
									if (isSelected) {
										return;
									} else {
										handleRowClick(d);
									}
								}}
								className={isSelected ? "selected-row" : ""}
							>
								<td>{d.master_vendor_name}</td>
								<td>
									{numberFormatter(
										d.spend + d.consolidatedCost,
										0,
										"$"
									)}
									{d.consolidatedCost > 0 && (
										<>
											{" "}
											<Whisper
												placement="top"
												speaker={
													<Tooltip className="tooltipconfig">
														<div>
															2026 Graybar Spend:{" "}
															{numberFormatter(
																d.spend,
																0,
																"$"
															)}
														</div>
														<div>
															2026 Subsidies
															Spend:{" "}
															{numberFormatter(
																d.consolidatedCost,
																0,
																"$"
															)}
														</div>
													</Tooltip>
												}
											>
												<InfoOutlineIcon className="ml-[.5vh] mb-[.5vh]" />
											</Whisper>
										</>
									)}
								</td>
								<td>{(d.rebate_base * 100).toFixed(2)}%</td>
								<td>
									{d.isReset
										? (
												d.tempAdjustedBestRebate * 100
										  ).toFixed(2)
										: (d.adjustedBestRebate * 100).toFixed(
												2
										  )}{" "}
									%
								</td>
								<td>
									{d.isReset
										? numberFormatter(
												(d.tempAdjustedBestRebate -
													d.rebate_base) *
													d.spend,
												0,
												"$"
										  )
										: numberFormatter(
												(d.adjustedBestRebate -
													d.rebate_base) *
													d.spend,
												0,
												"$"
										  )}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			<div className="text-[#666666] italic textNormal">
				Note: All the Spend / Sales above are adjusted with NIA $ & Cash
				Discounts
			</div>
		</div>
	);
};

export default SuppliersTable;
